<template>
  <td class="text-xs-right">{{ $d(new Date(value), format) }}</td>
</template>

<script>
export default {
  props: [ 'value', 'format' ]
}
</script>

